import { Storage } from "aws-amplify";

Storage.configure({
  AWSS3: {
    bucket: process.env.VUE_APP_S3_BUCKET,
    region: process.env.VUE_APP_S3_REGION,
  },
});

export default class S3Adapter {
  /**
   * Uploads file into Amazon S3
   * @param   {[type]}  fileName  [fileName description]
   * @param   {[type]}  file      [file.raw]
   * @param   {[type]}  option    [option description]
   * @return  {[type]}            [{key: S3 Object key}]
   */
  async put (fileName, file, option = {}) {
    const deferred = new Promise(async (resolve, reject) => {
      const result = await Storage.put(
        fileName,
        file,
        {
          ...option,

          // Storage 側で検知できるエラーはここで処理する
          // また他のイベントについては以下を参照（現在利用中のバージョンが v4.x のため v5.x の機能 resumable などの指定は行えません）
          // @see https://docs.amplify.aws/gen1/javascript/prev/build-a-backend/storage/upload/#event-handlers
          errorCallback: (err) => reject(err),
        },
      );

      // 引数が正しく指定されなかった場合 Storage.put の返り値（{key: S3 Object key}）が空で返ってくるためエラー処理しておく
      // ※ アダプタ自体の処理で発生するエラーとしての扱い（file.service 内で扱うのでも良いかも）
      if (!result.key) {
        reject(new Error("No storage key"));
      }

      resolve(result);
    });

    return deferred;
  }

  /**
   * Delete stored file and data from the storage bucket
   * @param   {[type]}  fileName  [fileName description]
   * @param   {[type]}  option    [option description]
   * @return  {[type]}            [return description]
   */
  async remove (fileName, option = {}) {
    try {
      await Storage.remove(fileName, option);

      return Promise.resolve();
    } catch (err) {
      return Promise.reject(err);
    }
  }

  /**
   * Get a Presigned URL of stored file
   * @param   {[type]}  key     [S3 Object key]
   * @param   {[type]}  option  [option description]
   * @return  {[type]}          [return description]
   */
  async get (key, option = {}) {
    try {
      const result = await Storage.get(key, option);

      return result;
    } catch (err) {
      console.log(err);
    }

    return "";
  }
}
